import { PageTitle } from '../components/layout/PageTitle';

interface PlaceholderPageProps {
  title: string;
  subtitle?: string;
}

const PlaceholderMessage = ({ name }: { name: string }) => (
  <div
    className="mgo-text-s mgo-color-muted"
    style={{ borderRadius: 'var(--mgo-radius-strong)', border: '1px solid var(--mgo-color-grey-05)', background: 'var(--mgo-color-bg-neutral-soft-unbordered)', padding: 'var(--mgo-space-60)' }}
  >
    This screen is not yet implemented. <span className="mgo-weight-strong">{name}</span> is a placeholder destination, ready to be replaced with its feature screen.
  </div>
);

/** Reusable, minimal full-page placeholder used for navigation items without a built screen. */
export const PlaceholderPage = ({ title, subtitle }: PlaceholderPageProps) => (
  <>
    <PageTitle title={title} subtitle={subtitle} />
    <PlaceholderMessage name={title} />
  </>
);

/** Compact placeholder used inside a tab panel, where the page heading is already shown. */
export const PlaceholderPanel = ({ name }: { name: string }) => (
  <PlaceholderMessage name={name} />
);
